import _ from 'lodash';
import {FETCH_AI_ADDONS, CLEAN_AI_ADDONS} from './types';
import { request, __ } from '../functions';
import {COOKIE_AI_ADDONS_NAME, COOKIE_SETTINGS} from "../config";

export const fetchAiAddons = (screen, options = {}) => {
    const { cookies } = screen.props;

    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-addons', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        if (!_.isEmpty(sync.user) && _.has(sync.user, 'ai_addons')) {
            // Nastavime
            cookies.set(COOKIE_AI_ADDONS_NAME, sync.user.ai_addons.toString(), COOKIE_SETTINGS);
        }

        dispatch({ type: FETCH_AI_ADDONS, payload: data });
    });
};

export const cleanAiAddons = () => ({ type: CLEAN_AI_ADDONS });
